import Entity from '../../schema/Entity';
import EntityType from '../../schema/innerSchema/EntityType';
import EntityTypeNames from '../../schema/innerSchema/EntityTypeNames';
import LodgingReservation from '../../schema/LodgingReservation';
import assignAddress from './assignAddress';
import checkEntityArray from './checkEntityArray';
import setReservationEntityData from './setReservationEntityData';
import tryCreateTxpOwaDate from './tryCreateTxpOwaDate';

/**
 * parse data for Lodging Entity
 */
export default function setLodgingReservationEntityData(
    entity: Entity,
    lodgingEntity: any
): LodgingReservation {
    if (entity && lodgingEntity) {
        if (isLodgingReservationValid(lodgingEntity, entity)) {
            let newLodgingEntity: LodgingReservation = setReservationEntityData(
                entity,
                lodgingEntity,
                true /* isReservationIdRequired */
            );

            newLodgingEntity = {
                ...newLodgingEntity,
                ...{
                    entityName: EntityTypeNames.LodgingReservation,
                    entityType: EntityType.LodgingReservation,
                    checkinTime: lodgingEntity.checkinTime,
                    checkoutTime: lodgingEntity.checkoutTime,
                    checkinTimeUTC: lodgingEntity['checkinTime/utc'],
                    checkoutTimeUTC: lodgingEntity['checkoutTime/utc'],
                    lodgingBusiness: {},
                },
            };

            const lodgingBusiness = checkEntityArray(newLodgingEntity.lodgingBusiness);

            // assign address
            lodgingBusiness.address = assignAddress({}, lodgingEntity.reservationFor.address);
            lodgingBusiness.name = lodgingEntity.reservationFor.name;

            return newLodgingEntity;
        }
    }
    return null;
}

export function isLodgingReservationValid(lodgingEntity: any, entity: Entity) {
    if (lodgingEntity) {
        if (
            lodgingEntity.checkinTime &&
            tryCreateTxpOwaDate(lodgingEntity.checkinTime, entity) &&
            lodgingEntity.checkoutTime &&
            tryCreateTxpOwaDate(lodgingEntity.checkoutTime, entity) &&
            lodgingEntity.reservationFor
        ) {
            return true;
        }
    }
    return false;
}
